export const ENV_ALLOWED_PROFILES = process.env.REACT_APP_ALLOWED_PROFILES.split(',');